import React from "react";
export default function Footer() {
  return <div>
    <h3>Presented by Henry Patterson</h3>
  </div>
}